<template lang="pug">
#ministries-tab
  b-table(
    :data="ministries"
    :current-page="pagination.page"
    :per-page="pagination.per"
    :total="pagination.total"
    @click="open"
    @dragstart="dragstart"
    @dragover="dragover"
    @dragleave="dragleave"
    @drop="drop"
    @page-change="getPage"
    backend-pagination
    draggable
    hoverable
    paginated
  )
    template(slot-scope="props")
      b-table-column(width="25")
        b-icon.drag-icon.has-text-grey-light(icon="drag-vertical")
      b-table-column(label="Name")
        span {{ props.row.name }}
      b-table-column(label="Contact")
        small(v-if="props.row.contact_name") {{ props.row.contact_name }}
        small.has-text-grey-light(v-else) NA
      b-table-column(label="Age/Grade Range")
        small(v-if="props.row.age_range") {{ props.row.age_range }}
        small.has-text-grey-light(v-else) NA
      b-table-column(label="Page")
        small
          a.has-text-primary(:href="`https://${account.host}/ministries/${props.row.key}`" target="_blank")
            span View
            b-icon(icon="open-in-new" size="is-small")
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import MinistryForm from '@/components/form/MinistryForm';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  name: 'ministries-tab',
  computed: {
    ...mapGetters({
      account: getters.GET_ACCOUNT,
      filters: getters.GET_MINISTRY_FILTERS,
      ministries: getters.GET_MINISTRIES,
      refresh: getters.GET_MINISTRY_REFRESH,
    }),
  },
  created() {
    this.getPage(1);
  },
  data() {
    return {
      dragging: null,
      settings: {
        loading: false,
      },
      pagination: {
        page: 1,
        per: 12,
        total: 0,
      },
    };
  },
  methods: {
    dragstart(payload) {
      this.dragging = payload.row;
      payload.event.dataTransfer.effectAllowed = 'copy';
    },
    dragover(payload) {
      payload.event.dataTransfer.dropEffect = 'copy';
      payload.event.target.closest('tr').classList.add('is-selected');
      payload.event.preventDefault();
    },
    dragleave(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected');
      payload.event.preventDefault();
    },
    async drop(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected');
      this.$store.commit(mutations.INSERT_MINISTRY, {
        index: payload.index,
        val: this.dragging,
      });
      const saveMinistries = [];
      this.ministries.forEach(ministry => saveMinistries.push(this.saveMinistry(ministry)));
      await Promise.all(saveMinistries);
      this.$store.commit(mutations.SET_APP_SNACKBAR, {
        type: 'is-success',
        message: 'Sort order updated',
      });
    },
    async getPage(page) {
      this.settings.loading = true;
      this.pagination.page = page;
      const payload = {
        page,
        zoom: 'profile_image',
      };
      if (this.filters.query) {
        payload.query = this.filters.query;
      }
      await this.$store.dispatch(actions.DO_GET_MINISTRIES, payload);
      setTimeout(() => {
        this.settings.loading = false;
        this.$store.commit(mutations.SET_MINISTRY_REFRESH, false);
      }, 250);
    },
    async open(ministry) {
      await this.$store.dispatch(actions.DO_GET_MINISTRY, {
        id: ministry.id,
        zoom: 'header_image,main_gallery,ministry_head,profile_image,roles,service_gallery',
      });
      this.$buefy.modal.open({
        parent: this,
        component: MinistryForm,
        hasModalCard: true,
      });
    },
    async saveMinistry(ministry) {
      const index = _.findIndex(this.ministries, { id: ministry.id });
      if (index >= 0) {
        await this.$store.dispatch(actions.DO_UPDATE_MINISTRY, {
          id: ministry.id,
          sort_order: index,
        });
      }
    },
  },
  watch: {
    refresh(val) {
      if (val) this.getPage(1);
    },
  },
};
</script>

<style lang="scss">
#ministries-tab {

}
</style>



// WEBPACK FOOTER //
// src/components/MinistriesTab.vue